import { createSagaAction } from '../../../shared/sagas'
import { createReducer } from '../../../shared/reducers'

// Constants
export const constants = {
  GET_SCHEDULE_APPLICATION_DATES: createSagaAction('GET_SCHEDULE_APPLICATION_DATES'),
  ADD_SCHEDULE_APPLICATION_DATE: createSagaAction('ADD_SCHEDULE_APPLICATION_DATE'),
  DELETE_SCHEDULE_APPLICATION: createSagaAction('DELETE_SCHEDULE_APPLICATION'),
  SCHEDULE_APPLICATION_UPDATE: createSagaAction('SCHEDULE_APPLICATION_UPDATE'),
  SCHEDULE_APPLICATION_UPDATE_NOTE: createSagaAction('SCHEDULE_APPLICATION_UPDATE_NOTE')
}

// Action Creators
export const actions = {
  getScheduleApplicationDates: ({ jobId }) => ({
    type: constants.GET_SCHEDULE_APPLICATION_DATES.ACTION,
    jobId
  }),

  addScheduleApplicationDate: ({ jobId, userId, scheduleId }) => ({
    type: constants.ADD_SCHEDULE_APPLICATION_DATE.ACTION,
    jobId,
    userId,
    scheduleId
  }),

  deleteScheduleApplication: ({ jobId, scheduleId }) => ({
    type: constants.DELETE_SCHEDULE_APPLICATION.ACTION,
    jobId,
    scheduleId
  }),

  updateApplicationDates: ({ jobId, userId, scheduleId, scheduleType, description, content }) => ({
    type: constants.SCHEDULE_APPLICATION_UPDATE.ACTION,
    jobId,
    scheduleId,
    userId,
    scheduleType,
    description,
    content
  }),

  updateNotes: ({ jobId, userId, scheduleId, notes }) => ({
    type: constants.SCHEDULE_APPLICATION_UPDATE_NOTE.ACTION,
    jobId,
    userId,
    scheduleId,
    notes
  })
}

// Reducer
const initialState = {}

export default createReducer(initialState, (state, action) => {
  switch (action.type) {
    case constants.AUTHENTICATION_LOGOUT:
      return initialState
    case constants.GET_SCHEDULE_APPLICATION_DATES.ACTION:
      return { ...state, error: null, loading: true }
    case constants.GET_SCHEDULE_APPLICATION_DATES.SUCCESS:
      return {
        ...state,
        scheduleApplicationDates: action.payload
      }
    case constants.GET_SCHEDULE_APPLICATION_DATES.FAILED:
      return {
        error: action.message
      }
    case constants.SCHEDULE_APPLICATION_UPDATE.SUCCESS:
      return {
        ...state
      }
    case constants.DELETE_SCHEDULE_APPLICATION.SUCCESS:
      return {
        ...state
      }
    case constants.ADD_SCHEDULE_APPLICATION_DATE.SUCCESS:
      return {
        ...state
      }
    case constants.SCHEDULE_APPLICATION_UPDATE_NOTE.SUCCESS:
      return {
        ...state
      }
    default:
      return state
  }
})



// WEBPACK FOOTER //
// ./src/redux/modules/jobFunctions/scheduleApplicationActions.js